export default "__VITE_ASSET__$F$0mTQP__"